module.exports = __webpack_public_path__ + "static/1-843a462ecb71ecc297cd555e2554d218.jpg";